var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"solapa overflow-y-hidden w-full h-8 bg-mercury justify-center items-center",class:{
    'active': _vm.isActive,
    'inactive': !_vm.isActive,
    'preload': _vm.preload,
    'overflow-y-scroll': _vm.isActive,
    'overflow-y-hidden': !_vm.isActive
  }},[_c('v-icon',{staticClass:"my-auto w-full",attrs:{"name":"chevron-up","scale":"1.45"},nativeOn:{"click":function($event){return _vm.toggleActive($event)}}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }